import { css } from '@emotion/react';
import { lighten } from '@mui/material/styles';

const makeClientApiStyles = ({ theme }) => {
  return {
    promptTextContainer: css({
      maxWidth: 640,
      margin: '0 auto 15px auto',
      textAlign: 'center',
    }),
    promptFooterContainer: css({
      marginTop: theme.mvf.spacing.large,
    }),
    yesButtonContainer: css({
      height: 55,
    }),
    noButton: css({
      color: theme.mvf.palette.text.primaryTextColor,
      backgroundColor: theme.mvf.palette.background.widgetBackgroundColor,
      marginTop: 10,
      height: 55,
      width: '100%',
      borderRadius: '6px',
      border: 'solid',
      borderWidth: theme.mvf.border.width.thin,
      borderColor: theme.mvf.palette.component.answerUnselectedColor,
      textTransform: 'none',
      fontWeight: theme.mvf.typography.weight.thick,
      fontSize: theme.mvf.fontSize.medium,
      '&:hover': {
        backgroundColor: theme.mvf.palette.background.widgetBackgroundColor,
      },
    }),
    heading: css({
      marginTop: 10,
      '& h6': {
        fontWeight: 900,
        textAlign: 'center',
        fontSize: 30,
        lineHeight: 1,
        fontFamily: 'Public Sans, Arial, sans-serif',
      },
    }),
    subheading: css({
      margin: '15px 0',
      '& p': {
        fontFamily: 'Public Sans, Arial, sans-serif',
      },
    }),
    footnote: css({
      marginTop: theme.mvf.spacing.small,
      '& p': {
        textAlign: 'center',
        fontFamily: 'Public Sans, Arial, sans-serif',
        color: lighten(
          theme.mvf.palette.text.secondaryTextColor,
          theme.mvf.filters.lighten.medium
        ),
      },
    }),
  };
};

export default makeClientApiStyles;
